var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useEffect, useState } from "react";
import { leadTableColumnSchema } from "../constants/table/leadTableColumnSchema";
import { Paginate } from "@domainpage/shared/src";
import { emitToastNotification } from "../utils";
import NotificationContext from "../context/NotificationContext";
import DashboardContext from "../context/DashboardContext";
import AuthContext from "../context/AuthContext";
import { Link, useHistory, useParams } from "react-router-dom";
import Stats from "./Stats";
import punycode from "punycode.js";
import { ChartSquareBarOutline, ClipboardCheckOutline, CogOutline, ExternalLinkOutline, EyeOutline } from "heroicons-react";
import GenericTable from "./table/GenericTable";
var DomainStats = function () {
    var _a = useContext(NotificationContext), notification = _a.state, dispatch = _a.dispatch;
    var _b = useContext(DashboardContext), dashboard = _b.state, dashboardDispatch = _b.dispatch;
    var auth = useContext(AuthContext).state;
    var history = useHistory();
    var _c = useState({}), data = _c[0], setData = _c[1];
    var _d = useState([]), leads = _d[0], setLeads = _d[1];
    var _e = useState(Paginate.PAGE), page = _e[0], setPage = _e[1];
    var params = useParams();
    var domainName = params.domain;
    var _f = useState(0), views = _f[0], setViews = _f[1];
    var _g = useState({}), paginateOptions = _g[0], setPaginateOptions = _g[1];
    var fetchDomainDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, notification_1, domainObj;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/api/domains/".concat(domainName))];
                case 1:
                    res = _a.sent();
                    if (!!res.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, res.json()];
                case 2:
                    notification_1 = _a.sent();
                    return [2 /*return*/, emitToastNotification(dispatch, notification_1)];
                case 3: return [4 /*yield*/, res.json()];
                case 4:
                    domainObj = _a.sent();
                    setData(domainObj.payload);
                    setViews(domainObj.payload.views);
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var fetchLeadsForDomain = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, notification_2, payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/api/leads/".concat(domainName))];
                case 1:
                    res = _a.sent();
                    if (!!res.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, res.json()];
                case 2:
                    notification_2 = _a.sent();
                    return [2 /*return*/, emitToastNotification(dispatch, notification_2)];
                case 3: return [4 /*yield*/, res.json()];
                case 4:
                    payload = (_a.sent()).payload;
                    setPaginateOptions(payload);
                    setLeads(payload.docs);
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteLeads = function (leadObjArr) { return __awaiter(void 0, void 0, void 0, function () {
        var leadIdsToBeDeletedArr, params, res, notification;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    leadIdsToBeDeletedArr = leadObjArr.map(function (lead) { return lead.original._id; });
                    params = {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ payload: leadIdsToBeDeletedArr }),
                    };
                    return [4 /*yield*/, fetch("/api/leads/delete", params)];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    notification = _a.sent();
                    emitToastNotification(dispatch, notification);
                    history.go(0);
                    return [2 /*return*/];
            }
        });
    }); };
    var stats = [
        { name: "Views", stat: views, icon: _jsx(EyeOutline, { className: "h-6 w-6 text-gray-400" }, void 0) },
        { name: "Leads", stat: leads.length, icon: _jsx(ClipboardCheckOutline, { className: "h-6 w-6 text-gray-400" }, void 0) },
        {
            name: "Lead Conversion %",
            stat: views ? (leads.length / views).toFixed(5) : 0,
            icon: _jsx(ChartSquareBarOutline, { className: "h-6 w-6 text-gray-400" }, void 0),
        },
    ];
    var initialState = {
        hiddenColumns: [],
        pageIndex: 0,
        pageSize: 0,
    };
    useEffect(function () {
        fetchDomainDetails().catch(function (err) { return err; });
    }, []);
    useEffect(function () {
        fetchLeadsForDomain().catch(function (err) { return err; });
    }, [page]);
    useEffect(function () { }, [leads]);
    return domainName ? (_jsx("div", __assign({ className: "mt-8" }, { children: _jsx("div", __assign({ className: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" }, { children: _jsxs("div", __assign({ className: "space-y-6" }, { children: [_jsxs("div", __assign({ className: "py-6 md:flex md:items-center md:justify-between lg:border-gray-200" }, { children: [_jsx("div", __assign({ className: "flex-1 min-w-0" }, { children: _jsx("div", __assign({ className: "flex items-center" }, { children: _jsx("div", { children: _jsx("div", __assign({ className: "flex items-center" }, { children: _jsx("h1", __assign({ className: "max-w-2xl break-all ml-3 text-2xl font-bold leading-7 text-gray-900 sm:leading-9" }, { children: punycode.toUnicode(domainName) }), void 0) }), void 0) }, void 0) }), void 0) }), void 0), _jsxs("div", __assign({ className: "mt-6 flex sm:space-x-3 md:mt-0 md:ml-4 mt-6 flex flex-col sm:ml-3 sm:mt-1 sm:flex-row sm:flex-wrap" }, { children: [_jsx(Link, __assign({ to: "/dashboard/domains/".concat(domainName, "/edit") }, { children: _jsxs("button", __assign({ type: "button", className: "mx-1 inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" }, { children: [_jsx(CogOutline, { className: "h-4 w-4 mr-1" }, void 0), "Domain Settings"] }), void 0) }), void 0), _jsxs("a", __assign({ href: "https://".concat(auth.user.username, ".").concat(process.env.REACT_APP_ROOT_URL, "/").concat(domainName), target: "_blank" }, { children: [_jsxs("button", __assign({ disabled: !data.public, type: "button", className: "".concat(!data.public ? "opacity-50 cursor-not-allowed" : "", " mx-1 my-2 sm:my-0 inline-flex items-center px-2.5 py-1.5 border border-indigo-500 shadow-sm text-xs font-medium rounded text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500") }, { children: [_jsx(ExternalLinkOutline, { className: "h-4 w-4 mr-1" }, void 0), "View Domain Page"] }), void 0), !data.public ? _jsx("p", __assign({ className: 'mt-2 text-right text-gray-500 text-xs' }, { children: "Domain is private." }), void 0) : null] }), void 0)] }), void 0)] }), void 0), _jsx(Stats, { data: stats }, void 0), _jsx("div", __assign({ className: "flex flex-col" }, { children: _jsx("div", __assign({ className: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }, { children: _jsx("div", __assign({ className: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }, { children: leads.length ? (_jsx(GenericTable, { data: leads, initialState: initialState, selectableRowTableOptions: { deleteCallback: handleDeleteLeads, entity: { singular: "Lead", plural: "Leads" } }, columnSchema: leadTableColumnSchema, paginateOptions: paginateOptions, pageCallback: setPage }, void 0)) : (_jsx("div", { children: _jsx("h3", __assign({ className: "mt-4 italic text-xs" }, { children: "No leads for this domain." }), void 0) }, void 0)) }), void 0) }), void 0) }), void 0)] }), void 0) }), void 0) }), void 0)) : null;
};
export default DomainStats;
